import React, { useState, useEffect } from 'react';
import { Box, Typography, Container, Button, CardMedia } from '@mui/material';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import SEO from '../../components/SEO';

const images = [
  '/images/Outd1.jpg',
  '/images/Outd2.jpg',
  '/images/Outd3.jpg',
  '/images/Outd4.jpg',
  '/images/Outd5.jpg',
  '/images/Outd6.jpg',
  '/images/Outd7.jpg',
  '/images/Outd8.jpg',
];

const OutdoorLighting = ({ darkMode }) => {
 
  const [showAllImages, setShowAllImages] = useState(false);

  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSeeMore = () => {
    setShowAllImages(true);
  };

  const handleSeeLess = () => {
    setShowAllImages(false);
  };

  const imagesToShow = showAllImages ? images : images.slice(0, 4);

  const chunkImages = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const imageRows = chunkImages(imagesToShow, 4);

  return (
    <>
      {/* SEO Meta Tags for Outdoor Lighting */}
      <SEO 
        title="Outdoor Lighting Services Western Province | Outdoor Event Lighting Colombo, Gampaha, Kalutara"
        description="Professional outdoor lighting services in Western Province, Colombo, Gampaha, Kalutara. Outdoor wedding lighting, event lighting, garden lights & pathway lights. Best outdoor lighting Sri Lanka."
        keywords="outdoor lighting services, outdoor event lighting Sri Lanka, outdoor wedding lighting Sri Lanka, outdoor lighting Colombo, outdoor lighting Western Province, outdoor lighting Gampaha, outdoor lighting Kalutara, led lights near me, string lights near me, outdoor led lights, garden lights, pathway lights, outdoor event lighting, wedding outdoor lights, professional lighting services, Colombo, Gampaha, Kalutara, Western Province, Kandy, Sri Lanka, Miracle Lighting"
        url="https://miraclelighting.lk/outdoor-lighting"
      />
      
      <Container
        sx={{
          py: 8,
          backgroundColor: darkMode ? '#000000' : '#FFFFFF',
          color: darkMode ? '#FFD700' : '#000',
          borderRadius: '8px',
        }}
    ><Typography
                           variant="h3"
                           gutterBottom
                           sx={{
                             mt: 4,
                             mb: 5,
                             color: darkMode ? '#FFD700' : '#000000',
                             textAlign: 'center',
                             fontWeight: 'bold',
                             textShadow: darkMode ? '0 2px 4px rgba(255, 215, 0, 0.5)' : '0 2px 4px rgba(0, 0, 0, 0.2)',
                             position: 'relative',
                           
                           }}
                         >
        Outdoor Lighting
      </Typography>
      <Typography variant="body1" paragraph sx={{ mt: 5, mb: 5, textAlign: 'center' }}>
     Illuminate your garden or event venue with stunning outdoor lighting that creates a captivating atmosphere. Our lighting designs are ideal for weddings, festivals, or night-time celebrations. With carefully placed lights, we ensure safety and style, making your event.
     </Typography>
      {/* Image Gallery */}
      <Box sx={{ mt: 4 }}>
        {imageRows.map((row, rowIndex) => (
          <Box 
            key={rowIndex}
            sx={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              justifyContent: 'center', 
              gap: 2, 
              mb: 2 
            }}
          >
            {row.map((image, index) => {
              const globalIndex = rowIndex * 4 + index;
              return (
                <Zoom key={globalIndex}>
                  <Box
                    sx={{
                      width: '150px',
                      height: '120px',
                      cursor: 'pointer',
                      border: darkMode ? '2px solid #FFD700' : '2px solid #1E90FF',
                      borderRadius: '8px',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': { transform: 'scale(1.1)' },
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={image}
                      alt={`Outdoor Lighting ${globalIndex + 1}`}
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                    />
                  </Box>
                </Zoom>
              );
            })}
          </Box>
        ))}
      </Box>

      {/* See More/See Less Button */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        {!showAllImages && images.length > 4 ? (
          <Button 
            onClick={handleSeeMore}
            sx={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: darkMode ? '#FFD700' : '#FFD700',
              color: 'black',
              '&:hover': {
                backgroundColor: darkMode ? '#4A4A4A' : '#4A4A4A',
                color: '#FFD700',
              },
            }}
          >
            See More
          </Button>
        ) : showAllImages ? (
          <Button 
            onClick={handleSeeLess}
            sx={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: darkMode ? '#FFD700' : '#FFD700',
              color: 'black',
              '&:hover': {
                backgroundColor: darkMode ? '#4A4A4A' : '#4A4A4A',
                color: '#FFD700',
              },
            }}
          >
            See Less
          </Button>
        ) : null}
      </Box>
    </Container>
    </>
  );
};

export default OutdoorLighting;